(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["Auth0ContactForm"] = factory(require("jquery"), require("lodash"));
	else
		root["Auth0ContactForm"] = factory(root["jquery"], root["lodash"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-env browser */
	
	exports.handleQueryString = handleQueryString;
	
	var _jquery = __webpack_require__(6);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(7);
	
	var _contactForm = __webpack_require__(4);
	
	var _contactForm2 = _interopRequireDefault(_contactForm);
	
	__webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Globals apis
	var $ = _jquery2.default;
	
	var ContactForm = function () {
	  function ContactForm(options) {
	    var _this = this;
	
	    _classCallCheck(this, ContactForm);
	
	    this.options = {
	      onModalOpen: function onModalOpen() {},
	      onFormSuccess: function onFormSuccess() {},
	      onFormFail: function onFormFail() {},
	      postUrl: 'https://auth0-marketing.run.webtask.io/contact-form',
	      modalTitle: 'Contact Sales Team',
	      name: '',
	      includePhoneField: false,
	      includeRoleField: false,
	      email: '',
	      phone: '',
	      company: '',
	      role: '',
	      message: '',
	      roles: ['Software Developer', 'Engineering Exec / Management', 'C-Level', 'IT operations', 'Product Management', 'Sales', 'Marketing', 'Security & Compliance', 'Other'],
	      source: 'pricing',
	      dictionary: {
	        name: 'Name',
	        email: 'Email address',
	        phone: 'Phone Number',
	        company: 'Company',
	        role: 'Role',
	        message: 'Message',
	        send: 'Send'
	      }
	    };
	
	    this.onInput = function (element) {
	      if (!element) return;
	
	      var _getElements = _this.getElements(),
	          companyElement = _getElements.companyElement;
	
	      var isRequired = !!element.attr('required');
	      var isEmail = element.attr('type') === 'email';
	
	      var validateOnInput = function validateOnInput() {
	        var value = element.val().trim();
	        var hasValue = !!value;
	        var checkOther = isRequired ? hasValue : true;
	        var checkEmail = isRequired || hasValue ? _this.isValidEmail(value) : true;
	
	        var isValid = function () {
	          if (isEmail) {
	            return checkEmail;
	          }
	
	          return checkOther;
	        }();
	
	        if (isValid) {
	          element.removeClass('has-error');
	        } else {
	          element.addClass('has-error');
	        }
	
	        if (isEmail && isValid) {
	          var emailDomain = value.replace(/.*@/, '');
	
	          if (!_this.isFreeEmail(emailDomain)) {
	            _this.autocompleteCompanyElement(emailDomain);
	          } else {
	            companyElement.val('');
	          }
	        }
	
	        return isValid;
	      };
	
	      element.on('input', validateOnInput);
	      element.on('invalid', function () {
	        return _this.setSubmitButtonState('error');
	      });
	    };
	
	    var dictionary = (0, _lodash.assign)({}, this.options.dictionary, options.dictionary);
	    this.options = (0, _lodash.assign)({}, this.options, options, { dictionary: dictionary });
	  }
	
	  /**
	   * Show Contact Form
	   */
	
	  // Default options
	
	
	  _createClass(ContactForm, [{
	    key: 'show',
	    value: function show(extendedOptions) {
	      this.options = (0, _lodash.assign)({}, this.options, extendedOptions);
	      this.reset();
	
	      var _getElements2 = this.getElements(),
	          modalRoot = _getElements2.modalRoot,
	          elements = _getElements2.elements;
	
	      var _options = this.options,
	          onModalOpen = _options.onModalOpen,
	          onFormSuccess = _options.onFormSuccess,
	          onFormFail = _options.onFormFail;
	
	
	      modalRoot.on('shown.bs.modal', function () {
	        return elements[0].focus();
	      });
	      modalRoot.modal();
	
	      onModalOpen();
	
	      var success = function success(metricsData) {
	        // Close modal when animation of submit button ends
	        setTimeout(function () {
	          return modalRoot.modal('hide');
	        }, 4000);
	        onFormSuccess(metricsData);
	      };
	      var fail = function fail(metricsData) {
	        onFormFail(metricsData);
	      };
	
	      this.setEventHandlers(success, fail);
	    }
	
	    /**
	     * Reset: unmount and mount component
	     */
	
	  }, {
	    key: 'reset',
	    value: function reset() {
	      var _options2 = this.options,
	          modalTitle = _options2.modalTitle,
	          name = _options2.name,
	          email = _options2.email,
	          phone = _options2.phone,
	          company = _options2.company,
	          role = _options2.role,
	          roles = _options2.roles,
	          message = _options2.message,
	          dictionary = _options2.dictionary,
	          includePhoneField = _options2.includePhoneField,
	          includeRoleField = _options2.includeRoleField;
	
	      var _getElements3 = this.getElements(),
	          modalRoot = _getElements3.modalRoot;
	
	      modalRoot.remove();
	      $('body').append((0, _contactForm2.default)({ modalTitle: modalTitle, name: name, email: email, phone: phone, company: company, role: role, roles: roles, message: message, dictionary: dictionary, includePhoneField: includePhoneField, includeRoleField: includeRoleField }));
	    }
	
	    /**
	     * Get DOM elements
	     */
	
	  }, {
	    key: 'getElements',
	    value: function getElements() {
	      var options = {
	        modalRoot: $('#contact-form-modal'),
	        formRoot: $('#contact-form-modal__form'),
	        companyElement: $('#contact-form-modal__company'),
	        elements: [$('#contact-form-modal__name'), $('#contact-form-modal__email'), $('#contact-form-modal__company'), $('#contact-form-modal__message')],
	        submitButton: $('#contact-form-modal__submit')
	      };
	
	      if (this.options.includePhoneField) {
	        options.elements.push($('#contact-form-modal__phone'));
	      }
	
	      if (this.options.includeRoleField) {
	        options.elements.push($('#contact-form-modal__role'));
	      }
	
	      return options;
	    }
	
	    /**
	     * Set event handlers: form onSubmit and element onInput
	     */
	
	  }, {
	    key: 'setEventHandlers',
	    value: function setEventHandlers(onFormSuccess, onFormFail) {
	      var _getElements4 = this.getElements(),
	          elements = _getElements4.elements;
	
	      elements.forEach(this.onInput);
	      this.onSubmit(onFormSuccess, onFormFail);
	    }
	
	    /*
	     * Realtime form field validation, based on his HTML attrs. Also enables company autocomplete
	     */
	
	  }, {
	    key: 'isValidEmail',
	
	
	    /*
	     * Check if is a valid email
	     */
	    value: function isValidEmail(email) {
	      // eslint-disable-next-line max-len, no-useless-escape
	      var emailRegex = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
	
	      return emailRegex.test(email);
	    }
	
	    /*
	     * Check if is an stock email domain
	     */
	
	  }, {
	    key: 'isFreeEmail',
	    value: function isFreeEmail(value) {
	      var freeEmails = ['gmail.com', 'live.com', 'hotmail.com', 'outlook.com', 'yahoo.com', 'aol.com', 'icloud.com', 'gmx.com', 'gmx.us', 'lycos.com', 'mail.com', 'inbox.com'];
	
	      return freeEmails.indexOf(value) > -1;
	    }
	
	    /*
	     * Autocomplete company field with Clearbit Company Autocomplete API
	     */
	
	  }, {
	    key: 'autocompleteCompanyElement',
	    value: function autocompleteCompanyElement(companyDomain) {
	      var _getElements5 = this.getElements(),
	          companyElement = _getElements5.companyElement;
	
	      var callback = function callback(data) {
	        if (!data.length) return;
	
	        companyElement.val(data[0].name);
	      };
	
	      $.get('https://autocomplete.clearbit.com/v1/companies/suggest?query=' + companyDomain, callback);
	    }
	
	    /*
	     * Handle form submit
	     */
	
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(successCallback, failCallback) {
	      var _this2 = this;
	
	      var postUrl = this.options.postUrl;
	
	      var _getElements6 = this.getElements(),
	          elements = _getElements6.elements,
	          formRoot = _getElements6.formRoot;
	
	      formRoot.submit(function (e) {
	        e.preventDefault();
	
	        _this2.setSubmitButtonState('process');
	
	        if (!_this2.checkElementsValidation()) return _this2.setSubmitButtonState('error');
	
	        var _getData = _this2.getData(elements),
	            data = _getData.data,
	            metricsData = _getData.metricsData;
	
	        return $.ajax({ type: 'POST', url: postUrl, data: data }).done(function () {
	          _this2.setSubmitButtonState('success');
	          _this2.cleanElementsValue();
	          successCallback(metricsData);
	        }).fail(function () {
	          _this2.setSubmitButtonState('error');
	          failCallback(metricsData);
	        });
	      });
	    }
	
	    /*
	     * Cleans elements value
	     */
	
	  }, {
	    key: 'cleanElementsValue',
	    value: function cleanElementsValue() {
	      var _getElements7 = this.getElements(),
	          elements = _getElements7.elements;
	
	      elements.filter(function (element) {
	        return !element.is('select');
	      }).forEach(function (element) {
	        return element.val('');
	      });
	    }
	
	    /*
	     * Change state of submit button
	     */
	
	  }, {
	    key: 'setSubmitButtonState',
	    value: function setSubmitButtonState(state) {
	      var _this3 = this;
	
	      var _getElements8 = this.getElements(),
	          submitButton = _getElements8.submitButton;
	
	      switch (state) {
	        case 'success':
	          submitButton.removeClass('btn-danger shake btn-loading').addClass('btn-success success tada').html('<span aria-hidden="true" class="btn-icon icon-budicon-390"></span> Sent');
	          setTimeout(function () {
	            return _this3.setSubmitButtonState('initial');
	          }, 3000);
	          break;
	
	        case 'error':
	          submitButton.removeClass('btn-success success btn-loading tada').addClass('btn-danger shake').html('<span aria-hidden="true" class="btn-icon icon-budicon-389"></span> Error');
	          setTimeout(function () {
	            return _this3.setSubmitButtonState('initial');
	          }, 2000);
	          break;
	
	        case 'process':
	          submitButton.removeClass('success btn-danger').addClass('btn-loading').html('<span aria-hidden="true" class="icon-rotating icon-budicon-330"></span>');
	          break;
	
	        default:
	          submitButton.removeClass('success btn-danger btn-loading tada shake').addClass('btn-success').html('Send');
	      }
	    }
	
	    /*
	     * Check elements validation
	     */
	
	  }, {
	    key: 'checkElementsValidation',
	    value: function checkElementsValidation() {
	      var _getElements9 = this.getElements(),
	          elements = _getElements9.elements;
	
	      var result = elements.map(this.checkElementValidation);
	      var isValid = result.every(function (valid) {
	        return !!valid;
	      });
	
	      return isValid;
	    }
	
	    /*
	     * Check element validation
	     */
	
	  }, {
	    key: 'checkElementValidation',
	    value: function checkElementValidation(element) {
	      var hasError = element.hasClass('has-error');
	      var isRequired = !!element.attr('required');
	      var hasValue = !!element.val().trim();
	      var isValid = !hasError && isRequired && hasValue;
	
	      return isValid;
	    }
	
	    /*
	     * Get form and metrics data
	     */
	
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _getElements10 = this.getElements(),
	          elements = _getElements10.elements;
	
	      var data = {};
	
	      var metricsData = {
	        path: window.location.pathname,
	        url: window.location.toString(),
	        title: document.title,
	        referrer: document.referrer
	      };
	
	      elements.forEach(function (element) {
	        var key = element.attr('name');
	        metricsData[key] = data[key] = element.val();
	      });
	
	      data.subject = this.options.source || 'New contact from: ' + window.location.pathname;
	      data.source = this.options.source;
	      data.referrer = window.location.pathname;
	
	      if (this.options.test) {
	        data.test = true;
	      }
	
	      metricsData.trackData = metricsData.email;
	      metricsData.track_data2 = metricsData.message;
	      metricsData.track_data3 = metricsData.name;
	      metricsData.track_data4 = metricsData.company;
	      metricsData.track_data5 = metricsData.role;
	      metricsData.track_data6 = metricsData.phone;
	
	      return { data: data, metricsData: metricsData };
	    }
	  }]);
	
	  return ContactForm;
	}();
	
	/**
	 * Handle query string to detect `?contact=true` and show contact form
	 */
	
	
	exports.default = ContactForm;
	function handleQueryString(options, showOpts) {
	  var _window$location = window.location,
	      href = _window$location.href,
	      search = _window$location.search;
	
	  // Check if actual url has a query string
	
	  var queryStringHas = function queryStringHas(query) {
	    return search.indexOf(query) > -1;
	  };
	
	  if (!queryStringHas('contact=true')) return;
	
	  // auto display modal if requested
	  var form = new ContactForm(options);
	  form.show(showOpts);
	
	  var _form$getElements = form.getElements(),
	      modalRoot = _form$getElements.modalRoot;
	
	  // Remove contact=true from the query string on modal close without browser reload
	
	
	  modalRoot.on('hidden.bs.modal', function () {
	    var newurl1 = href.replace('?contact=true', '');
	    var newurl2 = href.replace('contact=true', '');
	    var definitiveNewUrl = href !== newurl1 ? newurl1 : newurl2;
	
	    window.history.pushState({ path: definitiveNewUrl }, '', definitiveNewUrl);
	  });
	}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleQueryString = exports.default = undefined;
	
	var _contactForm = __webpack_require__(1);
	
	var _contactForm2 = _interopRequireDefault(_contactForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _contactForm2.default;
	exports.handleQueryString = _contactForm.handleQueryString;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(5);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (company, dictionary, email, includePhoneField, includeRoleField, message, modalTitle, name, phone, role, roles, undefined) {
	buf.push("<div id=\"contact-form-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"contact-form-title\" class=\"modal fade contact-form-modal\"><div class=\"modal-dialog\"><form id=\"contact-form-modal__form\" class=\"modal-content contact-form-modal__form\"><div class=\"modal-header has-border\"><button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close close\"><span aria-hidden=\"true\">&times;</span></button><h4 id=\"contact-form-title\" class=\"modal-title\">" + (jade.escape(null == (jade_interp = modalTitle) ? "" : jade_interp)) + "</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label for=\"contact-form-modal__name\" class=\"sr-only\">" + (jade.escape(null == (jade_interp = dictionary.name) ? "" : jade_interp)) + "</label><input id=\"contact-form-modal__name\" type=\"text\"" + (jade.attr("placeholder", "" + (dictionary.name) + "", true, true)) + " autocomplete=\"section-contact name\" name=\"name\"" + (jade.attr("value", "" + (name) + "", true, true)) + " required class=\"form-control contact-form-modal__name\"><span class=\"required\">*</span></div><div class=\"form-group\"><label for=\"contact-form-modal__email\" class=\"sr-only\">" + (jade.escape(null == (jade_interp = dictionary.email) ? "" : jade_interp)) + "</label><input id=\"contact-form-modal__email\" type=\"email\"" + (jade.attr("placeholder", "" + (dictionary.email) + "", true, true)) + " autocomplete=\"section-contact email\" name=\"email\"" + (jade.attr("value", "" + (email) + "", true, true)) + " required class=\"form-control contact-form-modal__email\"><span class=\"required\">*</span></div>");
	if ( includePhoneField)
	{
	buf.push("<div class=\"form-group\"><label for=\"contact-form-modal__phone\" class=\"sr-only\">" + (jade.escape(null == (jade_interp = dictionary.phone) ? "" : jade_interp)) + "</label><input id=\"contact-form-modal__phone\" type=\"text\"" + (jade.attr("placeholder", "" + (dictionary.phone) + "", true, true)) + " autocomplete=\"section-contact phone\" name=\"phone\"" + (jade.attr("value", "" + (phone) + "", true, true)) + " required class=\"form-control contact-form-modal__phone\"><span class=\"required\">*</span></div>");
	}
	buf.push("<div class=\"form-group\"><label for=\"contact-form-modal__company\" class=\"sr-only\">" + (jade.escape(null == (jade_interp = dictionary.company) ? "" : jade_interp)) + "</label><input id=\"contact-form-modal__company\" type=\"text\"" + (jade.attr("placeholder", "" + (dictionary.company) + "", true, true)) + " autocomplete=\"section-contact organization\" name=\"company\"" + (jade.attr("value", "" + (company) + "", true, true)) + " required class=\"form-control contact-form-modal__company\"><span class=\"required\">*</span></div>");
	if ( includeRoleField)
	{
	buf.push("<div class=\"form-group\"><label for=\"contact-form-modal__role\" class=\"sr-only\">" + (jade.escape(null == (jade_interp = dictionary.role) ? "" : jade_interp)) + "</label><div class=\"acf-custom-select\"><select id=\"contact-form-modal__role\" name=\"role\" required class=\"form-control contact-form-modal__role\">");
	// iterate roles
	;(function(){
	  var $$obj = roles;
	  if ('number' == typeof $$obj.length) {
	
	    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
	      var item = $$obj[$index];
	
	buf.push("<option" + (jade.attr("selected", item == role, true, true)) + ">" + (jade.escape((jade_interp = item) == null ? '' : jade_interp)) + "</option>");
	    }
	
	  } else {
	    var $$l = 0;
	    for (var $index in $$obj) {
	      $$l++;      var item = $$obj[$index];
	
	buf.push("<option" + (jade.attr("selected", item == role, true, true)) + ">" + (jade.escape((jade_interp = item) == null ? '' : jade_interp)) + "</option>");
	    }
	
	  }
	}).call(this);
	
	buf.push("</select></div><span class=\"required\">*</span></div>");
	}
	buf.push("<div class=\"form-group\"><label for=\"contact-form-modal__message\" class=\"sr-only\">" + (jade.escape(null == (jade_interp = dictionary.message) ? "" : jade_interp)) + "</label><textarea id=\"contact-form-modal__message\" rows=\"4\"" + (jade.attr("placeholder", "" + (dictionary.message) + "", true, true)) + " name=\"message\" required class=\"form-control contact-form-modal__message\">" + (jade.escape(null == (jade_interp = message) ? "" : jade_interp)) + "</textarea><span class=\"required\">*</span></div></div><div class=\"modal-footer\"><button id=\"contact-form-modal__submit\" type=\"submit\" class=\"btn btn-success btn-lg animated contact-form-modal__submit\">" + (jade.escape(null == (jade_interp = dictionary.send) ? "" : jade_interp)) + "</button></div></form></div></div>");}.call(this,"company" in locals_for_with?locals_for_with.company:typeof company!=="undefined"?company:undefined,"dictionary" in locals_for_with?locals_for_with.dictionary:typeof dictionary!=="undefined"?dictionary:undefined,"email" in locals_for_with?locals_for_with.email:typeof email!=="undefined"?email:undefined,"includePhoneField" in locals_for_with?locals_for_with.includePhoneField:typeof includePhoneField!=="undefined"?includePhoneField:undefined,"includeRoleField" in locals_for_with?locals_for_with.includeRoleField:typeof includeRoleField!=="undefined"?includeRoleField:undefined,"message" in locals_for_with?locals_for_with.message:typeof message!=="undefined"?message:undefined,"modalTitle" in locals_for_with?locals_for_with.modalTitle:typeof modalTitle!=="undefined"?modalTitle:undefined,"name" in locals_for_with?locals_for_with.name:typeof name!=="undefined"?name:undefined,"phone" in locals_for_with?locals_for_with.phone:typeof phone!=="undefined"?phone:undefined,"role" in locals_for_with?locals_for_with.role:typeof role!=="undefined"?role:undefined,"roles" in locals_for_with?locals_for_with.roles:typeof roles!=="undefined"?roles:undefined,"undefined" in locals_for_with?locals_for_with.undefined: false?undefined:undefined));;return buf.join("");
	}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Merge two attribute objects giving precedence
	 * to values in object `b`. Classes are special-cased
	 * allowing for arrays and merging/joining appropriately
	 * resulting in a string.
	 *
	 * @param {Object} a
	 * @param {Object} b
	 * @return {Object} a
	 * @api private
	 */
	
	exports.merge = function merge(a, b) {
	  if (arguments.length === 1) {
	    var attrs = a[0];
	    for (var i = 1; i < a.length; i++) {
	      attrs = merge(attrs, a[i]);
	    }
	    return attrs;
	  }
	  var ac = a['class'];
	  var bc = b['class'];
	
	  if (ac || bc) {
	    ac = ac || [];
	    bc = bc || [];
	    if (!Array.isArray(ac)) ac = [ac];
	    if (!Array.isArray(bc)) bc = [bc];
	    a['class'] = ac.concat(bc).filter(nulls);
	  }
	
	  for (var key in b) {
	    if (key != 'class') {
	      a[key] = b[key];
	    }
	  }
	
	  return a;
	};
	
	/**
	 * Filter null `val`s.
	 *
	 * @param {*} val
	 * @return {Boolean}
	 * @api private
	 */
	
	function nulls(val) {
	  return val != null && val !== '';
	}
	
	/**
	 * join array as classes.
	 *
	 * @param {*} val
	 * @return {String}
	 */
	exports.joinClasses = joinClasses;
	function joinClasses(val) {
	  return (Array.isArray(val) ? val.map(joinClasses) :
	    (val && typeof val === 'object') ? Object.keys(val).filter(function (key) { return val[key]; }) :
	    [val]).filter(nulls).join(' ');
	}
	
	/**
	 * Render the given classes.
	 *
	 * @param {Array} classes
	 * @param {Array.<Boolean>} escaped
	 * @return {String}
	 */
	exports.cls = function cls(classes, escaped) {
	  var buf = [];
	  for (var i = 0; i < classes.length; i++) {
	    if (escaped && escaped[i]) {
	      buf.push(exports.escape(joinClasses([classes[i]])));
	    } else {
	      buf.push(joinClasses(classes[i]));
	    }
	  }
	  var text = joinClasses(buf);
	  if (text.length) {
	    return ' class="' + text + '"';
	  } else {
	    return '';
	  }
	};
	
	
	exports.style = function (val) {
	  if (val && typeof val === 'object') {
	    return Object.keys(val).map(function (style) {
	      return style + ':' + val[style];
	    }).join(';');
	  } else {
	    return val;
	  }
	};
	/**
	 * Render the given attribute.
	 *
	 * @param {String} key
	 * @param {String} val
	 * @param {Boolean} escaped
	 * @param {Boolean} terse
	 * @return {String}
	 */
	exports.attr = function attr(key, val, escaped, terse) {
	  if (key === 'style') {
	    val = exports.style(val);
	  }
	  if ('boolean' == typeof val || null == val) {
	    if (val) {
	      return ' ' + (terse ? key : key + '="' + key + '"');
	    } else {
	      return '';
	    }
	  } else if (0 == key.indexOf('data') && 'string' != typeof val) {
	    if (JSON.stringify(val).indexOf('&') !== -1) {
	      console.warn('Since Jade 2.0.0, ampersands (`&`) in data attributes ' +
	                   'will be escaped to `&amp;`');
	    };
	    if (val && typeof val.toISOString === 'function') {
	      console.warn('Jade will eliminate the double quotes around dates in ' +
	                   'ISO form after 2.0.0');
	    }
	    return ' ' + key + "='" + JSON.stringify(val).replace(/'/g, '&apos;') + "'";
	  } else if (escaped) {
	    if (val && typeof val.toISOString === 'function') {
	      console.warn('Jade will stringify dates in ISO form after 2.0.0');
	    }
	    return ' ' + key + '="' + exports.escape(val) + '"';
	  } else {
	    if (val && typeof val.toISOString === 'function') {
	      console.warn('Jade will stringify dates in ISO form after 2.0.0');
	    }
	    return ' ' + key + '="' + val + '"';
	  }
	};
	
	/**
	 * Render the given attributes object.
	 *
	 * @param {Object} obj
	 * @param {Object} escaped
	 * @return {String}
	 */
	exports.attrs = function attrs(obj, terse){
	  var buf = [];
	
	  var keys = Object.keys(obj);
	
	  if (keys.length) {
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i]
	        , val = obj[key];
	
	      if ('class' == key) {
	        if (val = joinClasses(val)) {
	          buf.push(' ' + key + '="' + val + '"');
	        }
	      } else {
	        buf.push(exports.attr(key, val, false, terse));
	      }
	    }
	  }
	
	  return buf.join('');
	};
	
	/**
	 * Escape the given string of `html`.
	 *
	 * @param {String} html
	 * @return {String}
	 * @api private
	 */
	
	var jade_encode_html_rules = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;'
	};
	var jade_match_html = /[&<>"]/g;
	
	function jade_encode_char(c) {
	  return jade_encode_html_rules[c] || c;
	}
	
	exports.escape = jade_escape;
	function jade_escape(html){
	  var result = String(html).replace(jade_match_html, jade_encode_char);
	  if (result === '' + html) return html;
	  else return result;
	};
	
	/**
	 * Re-throw the given `err` in context to the
	 * the jade in `filename` at the given `lineno`.
	 *
	 * @param {Error} err
	 * @param {String} filename
	 * @param {String} lineno
	 * @api private
	 */
	
	exports.rethrow = function rethrow(err, filename, lineno, str){
	  if (!(err instanceof Error)) throw err;
	  if ((typeof window != 'undefined' || !filename) && !str) {
	    err.message += ' on line ' + lineno;
	    throw err;
	  }
	  try {
	    str = str || __webpack_require__(8).readFileSync(filename, 'utf8')
	  } catch (ex) {
	    rethrow(err, null, lineno)
	  }
	  var context = 3
	    , lines = str.split('\n')
	    , start = Math.max(lineno - context, 0)
	    , end = Math.min(lines.length, lineno + context);
	
	  // Error context
	  var context = lines.slice(start, end).map(function(line, i){
	    var curr = i + start + 1;
	    return (curr == lineno ? '  > ' : '    ')
	      + curr
	      + '| '
	      + line;
	  }).join('\n');
	
	  // Alter exception message
	  err.path = filename;
	  err.message = (filename || 'Jade') + ':' + lineno
	    + '\n' + context + '\n\n' + err.message;
	  throw err;
	};
	
	exports.DebugItem = function DebugItem(lineno, filename) {
	  this.lineno = lineno;
	  this.filename = filename;
	}


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = require("jquery");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = require("lodash");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// contact-form.js


// WEBPACK FOOTER //
// webpack:///contact-form.js